











































import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class HotelImage extends Vue {
  @Prop({ required: true }) slug!: string;
  @Prop({ required: true }) name!: string;
  @Prop({ default: '' }) location!: string;
  @Prop({ default: '' }) textPc!: string;
  @Prop({ default: '' }) textSp!: string;
  @Prop({ default: '' }) onsenName!: string;

  get logoLang(): string {
    return (this as any).$language.current === 'ja' ? 'ja' : 'en';
  }

  get isJapanese(): boolean {
    return (this as any).$language.current === 'ja';
  }
}
